import { cimAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { cimAPIUrls } from '../data';

type Return = {
  authUrl: string;
};

export type Params = {
  code?: string;
  company_id?: number;
};

export type GetXPMConnect = {
  return: Return;
};

export const getXPMConnect = withLogger(
  async (params?: Params): Promise<Return> => {
    const response = await cimAxiosClient.get<Promise<Return>>(
      cimAPIUrls.xpmConnect,
      {
        params: {
          code: params?.code ?? undefined,
          company_id: params?.company_id
            ? Number(params.company_id)
            : undefined,
        },
      },
    );

    return response.data;
  },
);
